import { loadStripe } from "@stripe/stripe-js";
let stripePromise = null;
/**
 * Get or initialize the Stripe instance
 * Lazy loads Stripe.js for better performance
 */
export function getStripe(publishableKey) {
    if (!stripePromise) {
        stripePromise = loadStripe(publishableKey);
    }
    return stripePromise;
}
/**
 * Create price configuration for tiers
 * Price IDs should come from environment/config
 */
export function createPriceConfig(prices) {
    return {
        starter: {
            tier: "starter",
            monthlyPriceId: prices.starter.monthly,
            yearlyPriceId: prices.starter.yearly,
            monthlyAmount: 999, // $9.99 in cents
            yearlyAmount: 9990, // $99.90 in cents (2 months free)
            tokenAllocation: 500000,
            features: [
                "500K tokens/month",
                "Voice input",
                "Calendar sync",
                "Priority support",
            ],
        },
        pro: {
            tier: "pro",
            monthlyPriceId: prices.pro.monthly,
            yearlyPriceId: prices.pro.yearly,
            monthlyAmount: 2999, // $29.99 in cents
            yearlyAmount: 29990, // $299.90 in cents (2 months free)
            tokenAllocation: 2000000,
            features: [
                "2M tokens/month",
                "Everything in Starter",
                "Team sharing",
                "API access",
                "Custom integrations",
            ],
        },
        byok: {
            tier: "byok",
            monthlyPriceId: prices.byok.monthly,
            yearlyPriceId: prices.byok.yearly,
            monthlyAmount: 1900, // $19.00 in cents
            yearlyAmount: 19000, // $190.00 in cents (2 months free)
            tokenAllocation: 0, // Unlimited with user's own API key
            features: [
                "Unlimited usage",
                "Use your own API key",
                "All Pro features",
                "Key encryption at rest",
            ],
        },
    };
}
//# sourceMappingURL=config.js.map